import { MouseEvent } from "react";
import { ElementFormatType, FORMAT_ELEMENT_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

import ToggleButtonGroup from "../ToggleButtonGroup/ToggleButtonGroup";
import ToolbarButton from "../ToolbarButton/ToolbarButton";
import { useToolbarContext } from "../../ToolbarContext";


export function AlignButtons() {
    const [editor] = useLexicalComposerContext();
    const { elementFormat } = useToolbarContext();


    const handleChange = (_event: MouseEvent<HTMLElement>, type: ElementFormatType) => {
        if (!type) {
            console.error("Element format type is null or undefined.");
            return;
        }

        // dispatch undo/redo command
        editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, type);
    };

    return (
        <ToggleButtonGroup exclusive onChange={handleChange} value={elementFormat}>
            <ToolbarButton value="left" tooltip="Left Align" aria-label="Left Align">
                <FormatAlignLeftIcon />
            </ToolbarButton>
            <ToolbarButton value="center" tooltip="Center Align" aria-label="Center Align">
                <FormatAlignCenterIcon />
            </ToolbarButton>
            <ToolbarButton value="right" tooltip="Right Align" aria-label="Right Align">
                <FormatAlignRightIcon />
            </ToolbarButton>
            <ToolbarButton value="justify" tooltip="Justify Align" aria-label="Justify Align">
                <FormatAlignJustifyIcon />
            </ToolbarButton>
        </ToggleButtonGroup>
    );
}

export default AlignButtons;